import request from '@/utils/request'
// 工作时长统计
export const pageList = (getData) => {
  return request({
    url: '/members-working-count/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 工作时长统计
export const pageListInfo = (getData) => {
  return request({
    url: '/members-working-count/pageListInfo',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
//车辆统计
export const carCount = (postData) => {
  return request({
    url: '/gps-cars-travel/pageList',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 车辆 详情 
export const carInfo = (postData) => {
  return request({
    url: '/gps-cars-travel/pageListInfo',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 车辆异常统计 
export const carAbnormal = (postData) => {
  return request({
    url: '/gps-cars-travel/pageListStop',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}